import { /*Link,*/ useNavigate } from "react-router-dom";
import { useRef, FormEvent, useState } from "react";
import { useUser } from "../Context/UserProvider";
import { useLoading } from "../Context/LoadingProvider";
import { LaravelValidationError } from "../Api/request";
import Logo from "../Assets/gfx/boolanga_bi.png";
import { useTranslation } from "react-i18next";
import LanguageSelector from "./LanguageSelector";

interface LoginProps {}

const Login: React.FunctionComponent<LoginProps> = () => {
  const emailRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);

  const { t } = useTranslation();

  const [validationErrors, setValidationErrors] = useState<Record<
    string,
    string[]
  > | null>(null);
  const navigate = useNavigate();
  const { login } = useUser();

  const { startLoading, finnishLoading } = useLoading();
    const [showPassword, setShowPassword] = useState(false);


    const handleLogin = async (e: FormEvent) => {
    e.preventDefault();

    if (emailRef.current && passwordRef.current) {
      startLoading("login-submit");
      login(emailRef.current.value, passwordRef.current.value)
        .then(() => {
          navigate("/menu");
        })
        .catch((error: LaravelValidationError) => {
          setValidationErrors(error.errors);
        })
        .finally(() => {
          finnishLoading("login-submit");
        });
    }
  };

  return (
    <div className="view-container flex items-center justify-center background-2">
      <div className="view-content">
        <div className="heading heading--small text-center">
          {t("Please login to your account")}
        </div>

        <div className="brand-logo-container">
          <img className="brand-logo" src={Logo} alt="Wear your brand logo" />
        </div>
        <LanguageSelector />
        <form onSubmit={handleLogin} className="w-full px-4">
          <div className="mb-4">
            <label
              className={
                "label-with-input" + (validationErrors?.email ? " error" : "")
              }
            >
              <div className="label-with-input__text">{t("Email")}</div>
              <input
                type="email"
                placeholder="Email"
                required
                ref={emailRef}
                autoComplete="email"
              />
            </label>

            {validationErrors?.email && (
              <div className="input-error-text">
                {validationErrors?.email?.map((x) => (
                  <>
                    <br />
                    <span key={x} style={{ color: "red" }}>
                      {x}
                    </span>
                  </>
                ))}
              </div>
            )}
          </div>

            <div className="mb-10">
                <label
                    className={
                        "label-with-input" + (validationErrors?.password ? " error" : "")
                    }
                    style={{ position: "relative" }}
                >
                    <div className="label-with-input__text">{t("Password")}</div>

                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        required
                        ref={passwordRef}
                        autoComplete="current-password"
                        style={{ paddingRight: "40px" }}
                    />

                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                            position: "absolute",
                            right: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: 0,
                        }}
                    >
                        {showPassword ? (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                style={{ width: "20px", height: "20px" }}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                                />
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                />
                            </svg>
                        ) : (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                                style={{ width: "20px", height: "20px" }}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M3.98 8.223A10.451 10.451 0 001.934 12C3.226 16.036 7.244 19 12 19c.97 0 1.91-.138 2.798-.395M6.228 6.228A10.45 10.45 0 0112 5c4.756 0 8.773 2.964 10.065 7a10.452 10.452 0 01-4.042 5.236M6.228 6.228L3 3m3.228 3.228L21 21"
                                />
                            </svg>
                        )}
                    </button>
                </label>


                {validationErrors?.password && (
                    <div className="input-error-text">
                        {validationErrors?.password?.map((x) => (
                            <>
                                <br />
                                <span key={x} style={{ color: "red" }}>
            {x}
          </span>
                            </>
                        ))}
                    </div>
                )}
            </div>

            {/*
          <div className="mb-20 text-center">
            <Link to="/forgot-password" className="text-white text-small">
              Forgot password?
            </Link>
                </div>*/}

          <div className="text-center">
            <button type="submit" className="button button--orange button--big">
              {t("Login")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
